import api from './authService';

export const supportChatApi = {
  getStatus: async () => {
    const response = await api.get('/support-chat/status');
    return response.data;
  },

  sendMessage: async ({ message, history, hints, signal }) => {
    const response = await api.post(
      '/support-chat/message',
      { message, history, hints },
      { signal, timeout: 90000 }
    );
    return response.data;
  },
};

const GUEST_STATUS_CACHE_KEY = 'guest-concierge-status-cache';
const GUEST_STATUS_CACHE_MS = 5 * 60 * 1000;

let guestStatusMemoryCache = null;
let guestStatusMemoryAt = 0;
let guestStatusInflight = null;

const readGuestStatusCache = () => {
  if (guestStatusMemoryCache && Date.now() - guestStatusMemoryAt < GUEST_STATUS_CACHE_MS) {
    return guestStatusMemoryCache;
  }
  try {
    const raw = sessionStorage.getItem(GUEST_STATUS_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.fetchedAt && Date.now() - parsed.fetchedAt < GUEST_STATUS_CACHE_MS) {
      guestStatusMemoryCache = parsed.data;
      guestStatusMemoryAt = parsed.fetchedAt;
      return parsed.data;
    }
  } catch {
    /* ignore */
  }
  return null;
};

const writeGuestStatusCache = (data) => {
  const fetchedAt = Date.now();
  guestStatusMemoryCache = data;
  guestStatusMemoryAt = fetchedAt;
  try {
    sessionStorage.setItem(
      GUEST_STATUS_CACHE_KEY,
      JSON.stringify({ fetchedAt, data })
    );
  } catch {
    /* ignore */
  }
};

export const getCachedGuestConciergeStatus = () => readGuestStatusCache();

export const guestConciergeApi = {
  getStatus: async ({ force = false } = {}) => {
    if (!force) {
      const cached = readGuestStatusCache();
      if (cached) return cached;
    }

    if (guestStatusInflight) {
      return guestStatusInflight;
    }

    guestStatusInflight = api
      .get('/public/support-chat/status', {
        retryOn429: true,
        max429Retries: 1,
      })
      .then((response) => {
        writeGuestStatusCache(response.data);
        return response.data;
      })
      .finally(() => {
        guestStatusInflight = null;
      });

    return guestStatusInflight;
  },

  sendMessage: async ({ message, history, hints, signal }) => {
    const response = await api.post(
      '/public/support-chat/message',
      { message, history, hints },
      { signal, timeout: 90000 }
    );
    return response.data;
  },
};
